
import moment from 'moment'

export default function formatDate(date) {
   let now = moment()
   let then = moment(date)
   let daysDifference = now.diff(then, 'days')
   if (daysDifference < 7) {
      let daysNumberDifference = now.dayOfYear() - then.dayOfYear()
      if (daysNumberDifference < 1) {
         return `Aujourd'hui, ${then.format('HH:mm')}`
      } else if (daysNumberDifference < 2) {
         return `Hier, ${then.format('HH:mm')}`
      } else {
         return then.format('dddd, HH:mm')
      }
   } else {
      return then.format('Do MMMM YYYY, HH:mm')
   }

   if (daysDifference < 1) {
      return `Aujourd'hui, ${then.format('HH:mm')}`
   } else if (daysDifference < 2) {
      return `Hier, ${then.format('HH:mm')}`
   } else if (daysDifference < 7) {
      return then.format('dddd, HH:mm')
   } else {
      return then.format('Do MMMM YYYY, HH:mm')
   }
}



// WEBPACK FOOTER //
// ./src/utilities/formatDate.js